<template>
  <div>
    <b-table
      class="is-middle"
      :loading="devices.loading"
      :data="devices.data"
      :current-page="devices.current_page"
      :per-page="devices.per_page"
      :total="devices.total"
      paginated
      backend-pagination
      pagination-position="bottom"
      @page-change="page => devices.changePage(page)"
    >
      <template slot-scope="props">
        <b-table-column custom-key="Device" width="80" centered>
          <device-image :model="props.row.model" style="height: 50px; width: 50px;"></device-image>
        </b-table-column>

        <b-table-column label="Code" width="300">
          <router-link :to="'/devices/' + props.row.device_id">
            <div>{{ props.row.code }}</div>
          </router-link>
          <small class="has-text-grey">#{{ props.row.device_id }}</small>
          <span v-if="props.row.state != 'active'" class="tag is-danger">{{ props.row.state }}</span>
        </b-table-column>

        <b-table-column label="Manufacturer">
          <div class="has-text-grey">
            <div>{{ props.row.manufacturer }}</div>
            <small>{{ props.row.model }}</small>
          </div>
        </b-table-column>

        <b-table-column label="OS">
          <div class="has-text-grey">
            <div>{{ props.row.os }}</div>
            <small>{{ props.row.os_version_number }}</small>
          </div>
        </b-table-column>

        <b-table-column label="App">
          <div class="has-text-grey">
            <div>{{ props.row.app_version }}</div>
          </div>
        </b-table-column>

        <b-table-column label="Сүүлд нээсэн" centered>
          <span class="has-text-grey" v-if="props.row.last_open">
            {{
            props.row.last_open.created_at
            }}
          </span>
        </b-table-column>

        <b-table-column centered>
          <button class="button is-small" @click="remove(props.row.device_id)">
            <b-icon icon="close" size="is-small"></b-icon>
            <span>Хасах</span>
          </button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>No device available.</p>
          </div>
        </section>
      </template>
    </b-table>

  </div>
</template>

<script>
import DeviceImage from "../../../../../components/DeviceImage";

export default {
  components: {
    DeviceImage
  },

  data() {
    return {
      devices: new window.PaginatedRemoteCollection(
        `/admin/api/users/${this.$route.params.id}/devices`
      ).load()
    };
  },

  methods: {
    remove(device) {
      this.$buefy.dialog.confirm({
        title: "Remove device",
        message: "Тухайн төхөөрөмжөөс таны нэвтэрсэн мэдээлэл хаагдах болно.",
        cancelText: "Цуцлах",
        confirmText: "Remove device",
        onConfirm: () => {
          new window.Form()
            .delete(
              "/admin/api/users/" + this.$route.params.id + "/devices/" + device
            )
            .then((response) => {
              this.$buefy.toast.open(response.message);
              this.devices.load();
            })
        }
      });
    }
  }
};
</script>
